import { render, staticRenderFns } from "./projectsRefunds.vue?vue&type=template&id=5cd599be&scoped=true&"
import script from "./projectsRefunds.vue?vue&type=script&lang=js&"
export * from "./projectsRefunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd599be",
  null
  
)

export default component.exports